import { weblinkFragment } from '../../graphql/fragments/weblinkFragment';
import { graphql } from '../../graphql/graphql';

const helmetFragment = graphql(`
  fragment Helmet on StatePage_Page {
    helmet {
      canonical
      title
      description
      siteName
    }
  }
`);

const breadCrumbsFragment = graphql(`
  fragment BreadCrumbs on StatePage_Page {
    breadCrumbs {
      title
      url
    }
  }
`);

const titleFragment = graphql(`
  fragment Title on StatePage_Page {
    title {
      parts
    }
  }
`);

const propertyCollectionsFragment = graphql(`
  fragment PropertyCollections on StatePage_Page {
    propertyCollections {
      subtitle
      title
      collectionType
      properties {
        address
        path
        image {
          ... on ListingImage {
            alt
            caption
            jpgUri: uri(width: 224, height: 126, imageMode: Crop, progressive: true)
            webpUri: uri(width: 224, height: 126, format: WEBP, imageMode: Crop, progressive: true)
          }
          ... on AerialImage {
            alt
            caption
            uri(width: _420P)
          }
        }
        badge {
          text
          variant
        }
        price {
          display
          sourceLevel
        }
        features {
          iconName
          title
          hoverTitle
          valueWithUnit
        }
        clickThroughTracking {
          pathname
          page
          element
          sourceType
        }
      }
      tracking {
        showMoreProperties {
          schema
          data {
            event_name
            in_page_source
            user_action
          }
        }
      }
      searchPageWebLink {
        title
        url
        isExternal
        variant
        tracking {
          clickThroughTracking {
            pathname
            page
            element
            sourceType
          }
        }
        key
      }
    }
  }
`);

const suburbsFragment = graphql(`
  fragment Suburbs on StatePage_Page {
    suburbs {
      title
      subtitle
      showMoreButton {
        title
      }
      items {
        visible {
          link {
            url
            title
          }
        }
        hidden {
          link {
            url
            title
          }
        }
      }
    }
  }
`);

const seoFooterFragment = graphql(
  `
    fragment SeoFooter on StatePage_Page {
      seoFooter {
        footerTabsV2 {
          title
          tabs {
            name
            tabContent {
              title
              links {
                ...WebLink
              }
            }
          }
        }
      }
    }
  `,
  [weblinkFragment],
);

export const statePageQuery = graphql(
  `
    query StatePageBySlug($slug: StatePageSlug!) {
      statePageBySlug(slug: $slug) {
        id
        slug
        ...Helmet
        ...BreadCrumbs
        ...Title
        ...PropertyCollections
        ...Suburbs
        ...SeoFooter
        vgDisclaimerHtml
      }
    }
  `,
  [
    helmetFragment,
    breadCrumbsFragment,
    titleFragment,
    propertyCollectionsFragment,
    suburbsFragment,
    seoFooterFragment,
  ],
);
